<template>
    <div class="apply-container">
        <!-- header 部分 -->
        <portal-header :transparent='false'></portal-header>
        <div class="apply-layout">
            <!-- 占位符 -->
            <div class="placeholder"
                 style="height:50px;"></div>
            <div class="apply-div">
                <div class="apply-title">
                    <span>{{$t('购买')}} - {{$t('套餐包')}}</span>
                </div>
                <!-- <div class="hint certification"
                     v-if="isAuthentStatus">
                    <i class="icon-prompt-1-o"></i>
                    <div class="hintFont">
                        <p>{{$t(`您尚未${authTypeName}认证，开通服务需要先进行${authTypeName}认证。`)}}<span @click="certificationFun">{{$t('立即认证')}}</span>&nbsp;&nbsp;{{$t(`若已提交${authTypeName}认证，审核将会在1-2天内完成，请耐心等待。`)}}</p>
                    </div>
                </div> -->
                <div class="apply-content">
                    <div class="env-item">
                        <div class="hint">
                            <!-- <i class="icon-prompt-1-o"></i> -->
                            <div class="hintFont">
                                <p> {{$t('1.针对HPC共享资源池的套餐包为折扣包，购买后即生效，在有效期内提交HPC作业则按照折扣包内的折扣进行最终价格结算（存储计费不包括在内），如果折扣包过期则按照标准价进行计算。')}}
                                </p>
                                <p> {{$t('2.折扣包无法叠加购买，同一时间周期内只能购买一个折扣包，折扣包不支持退订。如：某折扣包规格为5折，售价1000元/月，按量目录单价为1元/核/小时，则实际购买后按照0.5元/核/小时结算。')}}
                                </p>
                            </div>
                        </div>
                    </div>
                    <!-- loading组件 -->
                    <div v-if="loading"
                         class="custom-loading">
                        <loading :size="24"></loading>
                    </div>
                    <div v-else
                         class="components">
                        <!-- 申请 -->
                        <keep-alive>
                            <packageForm v-if="!step"
                                         ref="packageForm"
                                         :configData="pageconfigdata"
                                         :quiryPrice="quiryPrice"
                                         @getpackageData="getpackageData"></packageForm>
                            <!-- @inquiry="inquiryPrice" -->
                        </keep-alive>
                        <!-- 确认信息 -->
                        <confirm v-if="step === 1"
                                 :submitData="submitData"></confirm>
                        <!-- @inquiry="inquiryPrice" -->
                    </div>
                </div>
            </div>
        </div>
        <div class="apply-footer">
            <div class="footer-div">
                <div class="balance">
                    <span class="config">
                        <span class="tit">{{$t('费用')}}：</span>
                        <span class="cost"
                              v-if="priceLoading">
                            <Icon type="ios-loading"
                                  size=16
                                  class="demo-spin-icon-load rc-color-orange"></Icon>
                            <span class="font-size14">
                                {{$t('计算中')}}...
                            </span>
                        </span>
                        <span v-else
                              class="cost">
                            <span class="font-size14"
                                  style="color: #ff6a01;">{{$money(quiryPrice,5)}}</span>
                        </span>
                    </span>
                </div>
                <div class="btn-div">
                    <!-- :disabled="(isNoYaml&&$refs.inquiryPrice.price!==null)||!isBtnShow" -->
                    <Button v-if="step === 0"
                            type="primary"
                            @click="gotoNext(1)">{{$t('下一步')}}</Button>
                    <Button v-if="step === 1"
                            type="default"
                            @click="gotoNext(0)"
                            class="mar-right15">{{$t('上一步')}}</Button>
                    <Button v-if="step === 1"
                            type="primary"
                            :disabled="!isBtnShow || isFreezeStatus ||isBizBagFreezeStatus|| isAuthentStatus"
                            :loading="submitLoading"
                            @click="submit">
                        <span v-if="isFreezeStatus||isBizBagFreezeStatus">{{$t('用户已冻结')}}</span>
                        <span v-else>{{isAuthentStatus?this.$t(`未${this.authTypeName}认证`):submitLoading? $t('提交中') : $t('立即购买')}}</span>
                    </Button>
                </div>
            </div>
        </div>
        <!--倒计时-->
        <countdown ref="countdown"
                   :txt="msg"
                   :jumpTxt="$t('我的订单')"
                   jumpLink="/mgt/order"
                   width='500'>
        </countdown>
    </div>
</template>

<script>
import countdown from '@c/basic/countdown'
import API from '@/service/api.js'
import portalHeader from '@c/portal/header'
import loading from '@c/basic/loading'
import confirm from './components/package/confirm'
import packageForm from './components/package/packageform.vue'

// import inquiryPrice from '@c/console/inquiry-price'
export default {
    name: 'hpcApplyProduct',
    components: {
        countdown,
        packageForm,
        portalHeader,
        loading,
        // inquiryPrice,
        confirm
    },
    data () {
        return {
            isBtnShow: false,
            loading: false,
            submitLoading: false,
            pageconfigdata: {}, // 规格和时间
            quiryPrice: null,
            envDataList: [],
            selectedEnvSid: null,
            step: 0,
            isNoYaml: false,
            inquiryFlag: null, // 询价节流
            priceLoading: false,
            submitData: { // 表单数据
                zeroData: null
            },
            authType: this.$store.state.user.currentUser.info.authType
        }
    },
    computed: {
        isFreezeStatus () { // 冻结
            return this.$store.state.user.currentUser.isFreezeStatus
        },
        isBizBagFreezeStatus () {
            // 套餐包是否冻结
            return this.$store.state.user.currentUser.isBizBagFreezeStatus
        },
        // 是认证  为ture表示认证失败
        isAuthentStatus () {
            const userAuth = this.$store.state.user.currentUser.info.authentStatus
            const comAuth = this.$store.state.user.currentOrg.certificationStatus
            const flag = this.authType === 'company' ? comAuth !== 'authSucceed' : userAuth !== 'authSucceed'
            return flag
        },
        authTypeName () {
            return this.authType === 'company' ? '企业' : '实名'
        },
        userAccount () {
            const userData = this.$store.state.user.currentUser.info || {}
            return userData.account
        },
        msg () {
            return `${this.userAccount}，${this.$t('请您耐心等待审核。若有问题，可通过工单联系运营管理员进行处理')}`
        }
    },
    watch: {
    },
    created () {
        // 初始化
        this.init()
    },
    methods: {
        certificationFun () {
            const path = this.authType === 'company' ? '/mgt/authent/company' : '/mgt/authent'
            this.$router.push({
                path: path + '?id=' + this.UserSid
            })
        },
        init () {
            // 获取服务相关数据
            this.loading = true
            this.axios.get(this.urlFormat(API.GET_BAG_BUY + '?productType=HPC&status=online', false)).then(res => {
                this.loading = false
                if (res) {
                    this.pageconfigdata = Object.assign({}, res)
                }
            }).catch(() => {
                this.loading = false
            })
        },
        gotoNext (val) {
            if (val === 1) {
                // 检验资源组件
                const stepZeroData = this.$refs.packageForm.validate()
                stepZeroData.valid.then((valid) => {
                    if (valid) {
                        this.submitData.zeroData = stepZeroData.data
                        this.step = val
                        // if (this.$store.state.user.currentUser.info.parentSid && this.$store.state.user.currentUser.info.parentSid !== null) {
                        //     this.$Message.error(this.$t('子用户无开通权限！'))
                        // } else if (this.serviceData.serviceType === 'HPC') {
                        //     // 判断hpc是否开通
                        //     this.axios.get(this.urlFormat(API.GET_HPC_STATUS, true)).then(res => {
                        //         if (res && res.length > 0) {
                        //             this.$Message.error(this.$t('HPC不能重复开通！'))
                        //         } else {
                        //             this.submitData.zeroData = stepZeroData.data
                        //             this.step = val
                        //         }
                        //     })
                        // } else {
                        //     this.submitData.zeroData = stepZeroData.data
                        //     this.step = val
                        // }
                    }
                })
            } else {
                this.step = val
            }
        },
        getpackageData (params, step, callback) {
            if (step === 'zero') {
                this.submitData.zeroData = params
            } else {
                // this.submitData.oneData = params
            }
            // 限流，防止询价过快
            this.priceLoading = true
            if (!this.inquiryFlag) {
                this.inquiryFlag = setTimeout(() => {
                    this.inquiryFlag = null
                    const itemPrice = JSON.parse(params.specValue).filter(item => item.id === params.timesId)[0]
                    this.submitData.zeroData.times = itemPrice.period % 12 === 0 ? itemPrice.period / 12 + this.$t('年') : itemPrice.period + this.$t('个月')
                    const price = itemPrice.price * params.quantity - params.discount
                    this.quiryPrice = price > 0 ? price : 0
                    this.priceLoading = false
                    if (this.quiryPrice !== null) {
                        this.isBtnShow = true
                    }
                }, 500)
            }
        },
        submit () {
            const applyData = {
                orderType: 'apply',
                // type: this.submitData.zeroData.type,
                quantity: this.submitData.zeroData.quantity,
                couponId: this.submitData.zeroData.couponId, // 优惠券id
                id: this.submitData.zeroData.timesId // 折扣id

            }
            // 提交数据
            this.submitLoading = true
            this.axios.post(this.urlFormat(API.POST_BAG_SUBSCRIBE, false), applyData, { headers: { showMsg: false } }).then((result) => {
                if (result === 'SUCCESS' || result.status) {
                    this.$refs.countdown.goChoicePeople(null)
                    this.submitLoading = false
                } else {
                    result.message && this.$Message.error({ content: result.message, duration: 5 })
                    this.submitLoading = false
                }
            }).catch(() => {
                this.submitLoading = false
            })
        }
    }
}
</script>
<style lang="less">
.apply-container {
    .ivu-select-selected-value {
        font-size: 12px !important;
    }
    .ivu-select-placeholder {
        font-size: 12px !important;
    }
}
.hint.certification i {
    color: #ff8400;
}
.hint.certification {
    background: rgba(255, 250, 238, 0.5);
    border-color: rgba(250, 224, 188, 1);
}
</style>>
<style lang="less" scoped>
.apply-container {
    width: 100%;
    height: 100%;
    overflow: hidden;
    .apply-layout {
        width: 100%;
        height: calc(~'100% - 60px');
        .hint.certification {
            width: 1000px;
            margin: 0 auto 15px auto;
            .hintFont {
                p {
                    span {
                        color: #ff8400;
                        font-weight: 500;
                        cursor: pointer;
                        text-decoration: underline;
                    }
                }
            }
        }
        .placeholder {
            width: 100%;
            height: 100px;
            background: black;
        }
        .apply-div {
            width: 100%;
            height: calc(~'100% - 41px');
            position: relative;
            overflow-y: auto;
            padding: 0px 0px 15px 0px;
            background: #f5f6f7;
            .apply-title {
                width: 100%;
                height: 50px;
                padding-left: 15px;
                line-height: 50px;
                margin: 0 auto;
                margin-bottom: 15px;
                background: #fff;
                font-weight: 600;
                font-size: 14px;
            }
            .apply-content {
                width: 1000px;
                margin: 0 auto;
                // min-height: calc(~'100% - 65px');
                background: #fff;
                .env-item {
                    padding: 20px 32px 0 32px;
                    .label {
                        display: inline-block;
                        width: 90px;
                        padding: 10px 12px 10px 0;
                        font-size: 12px;
                        text-align: right;
                    }
                    .config {
                        display: inline-block;
                    }
                }
                .custom-loading {
                    padding-right: 300px;
                }
            }
        }
    }
    .apply-footer {
        width: 100%;
        height: 60px;
        background: #fff;
        margin: 0 auto;
        border-top: 1px solid #e9e9e9;
        .footer-div {
            width: 1000px;
            height: 60px;
            margin: 0 auto;
            display: flex;
            .balance {
                width: 700px;
                height: 60px;
                line-height: 60px;
                padding-left: 10px;
                .cost {
                    color: #f57d18;
                }
                .tit {
                    padding-left: 10px;
                }
            }
            .btn-div {
                width: 300px;
                height: 60px;
                line-height: 60px;
                text-align: right;
                padding-right: 4px;
            }
        }
    }
}
</style>
